import {
  START_MULTIPLE_MODELING
} from './actionTypes';

export const startMultipleModeling = (verificationIds, verificationId) => ({
  type: START_MULTIPLE_MODELING,
  verificationIds,
  verificationId
});